import React, { useState, useEffect } from 'react';
import Main from './Main'
import Jouluvalot from './Jouluvalot'
export default function App(props) {

  let [disabledSnow, setDisabledSnow] = useState(false)

  return (
    <>
    <Main setDisabledSnow={setDisabledSnow}/>
    {navigator.userAgent.indexOf("Firefox") === -1 && !disabledSnow &&
      <Jouluvalot />
    }
    </>
  );

}
